import { useState, useEffect } from 'react';
import { doc, onSnapshot } from 'firebase/firestore';
import { db } from '../firebase/config';

/**
 * Hook para buscar o agregado de posts do blog em tempo real
 * Reduz drasticamente leituras do Firebase e atualiza automaticamente
 */
export const useBlogPostsAggregate = () => {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    setLoading(true);
    setError(null);

    const blogPostsAggregateRef = doc(db, 'agregadoPostsBlog', 'all');
    
    // Listener em tempo real
    const unsubscribe = onSnapshot(
      blogPostsAggregateRef,
      (snapshot) => {
        try {
          if (snapshot.exists()) {
            const data = snapshot.data();
            const postsArray = data.posts || [];
            
            // Converter Timestamps para Dates
            const postsData = postsArray.map((post) => {
              return {
                ...post,
                criadoEm: post.criadoEm?.toDate ? post.criadoEm.toDate() : new Date(post.criadoEm),
                atualizadoEm: post.atualizadoEm?.toDate ? post.atualizadoEm.toDate() : (post.atualizadoEm ? new Date(post.atualizadoEm) : null)
              };
            });
            
            // Ordenar por data de criação (mais recente primeiro)
            postsData.sort((a, b) => {
              const dateA = a.criadoEm instanceof Date ? a.criadoEm : new Date(a.criadoEm);
              const dateB = b.criadoEm instanceof Date ? b.criadoEm : new Date(b.criadoEm);
              return dateB.getTime() - dateA.getTime();
            });
            
            setPosts(postsData);
          } else {
            // Se o agregado não existe, retornar array vazio (não lançar erro)
            setPosts([]);
          }

          setLoading(false);
        } catch (err) {
          setError(err);
          setLoading(false);
        }
      },
      (err) => {
        // Callback de erro do onSnapshot
        setError(err);
        setLoading(false);
      }
    );

    // Cleanup: remover listener quando o componente desmontar
    return () => {
      unsubscribe();
    };
  }, []);

  return { posts, loading, error };
};
